import { createApiClientPlugin } from '@space/shared-api-client'

import { httpClient } from '@/shared/api/httpClient'

export const apiClientPlugin = createApiClientPlugin({
  client: httpClient,
})

export const apiClientInjectionKey = apiClientPlugin.injectionKey


